import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class serviceTypesDisplayListCtrl implements IController {
  ids: any;
  isRow: any;
  rowLimit: any;
  onChange: Function;

  private displayItems: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    // if (this.ids && this.ids.length) {
    //
    // } else {
    //   this.displayItems = [];
    // }
  }

  $onChanges(changes) {
    if (changes.ids) {
      this.$onInit();
    }
  }

  onRemove(id) {
    this.onChange({ids: _.filter(this.ids, (i) => {return i !== id})});
  }



}

angular
  .module('bringoz.admin.commons')
  .component('serviceAreaTypesDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./service-area-types-display-list.html').default,
    controller: serviceTypesDisplayListCtrl
  });
